export default __webpack_public_path__ + "static/positive1-1d5c93ccfbe0f454a2c9572cd137f4f7.jpg";